// extracted by mini-css-extract-plugin
export default {"outlined_btn":"OutlinedButton_outlined_btn__zcp9l","outlined_btn_md":"OutlinedButton_outlined_btn_md__hIOfk"};